import { useEffect, useRef, useState } from 'react';
import GetChannelRegistrantCounts from '../audiences/channel-registrant-counts';
import { ChannelRegistrantCounts } from '@/types/registration.types';
import { useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { useProjectUuidParam } from '@/utils/use-project-uuid-param';

export default function useChannelRegistrantCounts() {
  const channel = useAppSelector(getActiveChannel);
  const projectUuid = useProjectUuidParam();
  const [channelRegistrantCounts, setChannelRegistrantCounts] = useState<ChannelRegistrantCounts | undefined>(
    undefined
  );

  const fetching = useRef(false);

  useEffect(() => {
    if (fetching.current || !channel || !projectUuid) return;

    fetching.current = true;

    const fetchChannelRegistrantCounts = async () => {
      const abortController = new AbortController();

      try {
        const channelRegistrantCounts = await GetChannelRegistrantCounts({
          channel,
          projectUuid,
          signal: abortController.signal,
        });
        setChannelRegistrantCounts(channelRegistrantCounts.data);
      } catch (error) {
        console.error('Error fetching registrant counts', error);
        fetching.current = false;
      }

      return () => abortController.abort();
    };

    fetchChannelRegistrantCounts();
  }, [channel, projectUuid]);

  return channelRegistrantCounts;
}
